import DemandedJobCard from "./JobCard";
import Carousel from "../utils/Carousel";
import './DemandedJobs.scss';
import Image1 from "../../images/Rectangle_978.png"
import Image2 from "../../images/Rectangle_979.png"
import Image3 from "../../images/Rectangle_980.png"
import Image4 from "../../images/Rectangle_981.png"
import Image5 from "../../images/Rectangle_982.png"
import Header from "../utils/Header";
import toList from "../utils/ComponentUtil";

function DemandedJobs() {
    const jobs = [
        {
            img: Image1,
            name: 'Proof Reading',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/custom/proof-reading'
        },
        {
            img: Image2,
            name: 'Content Writing',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/custom/content-writing'
        },
        {
            img: Image3,
            name: 'Music & Audio',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/custom/new-proof-reading'
        },
        {
            img: Image4,
            name: 'Programming & Tech ',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/programming'
        },
        {
            img: Image5,
            name: 'Video & Animation',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/video-editing'
        },
        {
            img: Image1,
            name: 'Proof Reading',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/custom/proof-reading'
        },
        {
            img: Image2,
            name: 'Content Writing',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/custom/content-writing'
        },
        {
            img: Image3,
            name: 'Music & Audio',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/custom/new-proof-reading'
        },
        {
            img: Image4,
            name: 'Programming & Tech ',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/programming'
        },
        {
            img: Image5,
            name: 'Video & Animation',
            earning: 'Rs.5000/-',
            frequency: 'Per Day',
            to: '/internships/video-editing'
        },
    ]
    return (<div className="demanded-jobs-wrp wrapper">
        <Header title='Most Demanded Job Categories' subTitle='Choose your lovable job'/>
        <Carousel numberOfCards={4} centerMode={true} cards={toList(jobs, DemandedJobCard)}></Carousel>
    </div>);
}

export default DemandedJobs;